export default "__VITE_ASSET__Dk8lO3p1__"